'use strict'

import Controller from './components/Controller.js'
new Controller().init()
